import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('grouping.header'),
      path: 'configurations',
      use_parent_params: true,
      // params_required: ['id'],
      registerNavFromMenu: true,
      sc: [
        {
          name: i18n.tc('companies.entity_name', 2),
          path: 'configurations/grouping/companies/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('agenda.sellers'),
          path: 'configurations/grouping/sellers/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('agenda.buyers'),
          path: 'configurations/grouping/buyers/main',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
